module.exports = __webpack_public_path__ + "assets/images/pages/ebaysocial/icon-ebaysocial-1.png?d396fa69";